import React from "react";

const Pagination = ({
  page,
  totalPages = 1,
  totalCount = 0,
  perPage = 5,
  onPageChange,
  onPerPageChange,
  variant = "full",
  summary = "",
}) => {
  const isSimple = variant === "simple";

  const handlePrev = () => {
    if (page > 1) onPageChange(page - 1);
  };

  const handleNext = () => {
    if (page < totalPages) onPageChange(page + 1);
  };

  const handlePerPageChange = (e) => {
    onPerPageChange(Number(e.target.value));
  };

  const getPages = () => {
    const pages = [];

    const maxVisible = 5; 
    const sidePages = 1; 

    let start = Math.max(page - Math.floor(maxVisible / 2), 1);
    let end = Math.min(start + maxVisible - 1, totalPages);

    if (end === totalPages) {
      start = Math.max(end - maxVisible + 1, 1);
    }

    for (let i = 1; i <= Math.min(sidePages + 1, totalPages); i++) {
      pages.push(i);
    }

    if (start > sidePages + 2) {
      pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      if (i > sidePages + 1 && i < totalPages - sidePages) {
        pages.push(i);
      }
    }

    if (end < totalPages - sidePages - 1) {
      pages.push("...");
    }

    for (
      let i = Math.max(totalPages - sidePages, sidePages + 2);
      i <= totalPages;
      i++
    ) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className={`table-footer ${isSimple ? "table-footer--simple" : ""}`}>
      {isSimple ? (
        <span className="pagination-summary">{summary}</span>
      ) : (
        <div className="entries">
          <select value={perPage} onChange={handlePerPageChange}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          {" "}of {totalCount} entries
        </div>
      )}

      <div className={`pagination ${isSimple ? "pagination--simple" : ""}`}>
        <button
          type="button"
          className={isSimple ? "page-btn-simple" : "page-btn"}
          disabled={page === 1}
          onClick={handlePrev}
        >
          Previous
        </button>

        {!isSimple &&
          getPages().map((item, index) => {
            if (item === "...") {
              return (
                <span key={index} className="dots">
                  ...
                </span>
              );
            }

            return (
              <button
                key={item}
                type="button"
                className={`page-btn-blue ${page === item ? "active" : ""}`}
                onClick={() => onPageChange(item)}
              >
                {item}
              </button>
            );
          })}

        <button
          type="button"
          className={isSimple ? "page-btn-simple" : "page-btn"}
          disabled={page === totalPages}
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;